<script setup lang="ts">
/**
 * Appoint / Withdraw CEO (B32114) — Directors' Resolution in Writing (Appointment & Resignation of CEO).
 *   원본: DR-appt n withdrawal of CEO.docx (…/SG/프리셋/Appoint   Withdraw Ceo/_lettaga_templatized)
 *   토큰: company_name / company_registration_no(머리글 UEN) / ceo_name · ceo_appointment_date /
 *         resigning_ceo_name · ceo_resignation_date / resolution_date("Dated this") / [[Signers]](이사 전원 → dr_Signers)
 *   결의 행은 [[if include_ceo_appointment]] / [[if include_ceo_resignation]] — 선택한 결의만 표시.
 */
import CddVarField from '../final-dividends/cdd/CddVarField.vue';
import AgmSigners from '../final-dividends/cdd/AgmSigners.vue';
import '../final-dividends/docs/agmDoc.css';

withDefaults(defineProps<{ showAppointment?: boolean; showResignation?: boolean }>(), { showAppointment: true, showResignation: true });
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><u><CddVarField field-key="company_name" label="Company Name" /></u></b></div>
      <div>Incorporated in the Republic of Singapore</div>
      <div>Unique Entity Number: <CddVarField field-key="company_registration_no" label="UEN" /></div>
      <div>(&ldquo;the Company&rdquo;)</div>
    </div>

    <div class="doc-title ceo-title">DIRECTORS' RESOLUTION IN WRITING PASSED PURSUANT TO THE COMPANY'S CONSTITUTION</div>

    <div v-if="showAppointment" class="ceo-row">
      <div class="ceo-h">APPOINTMENT OF CHIEF EXECUTIVE OFFICER</div>
      <div>
        <div class="ceo-resolved">RESOLVED &ndash;</div>
        <p class="doc-p">
          That the Company do approve the appointment of
          <b><CddVarField field-key="ceo_name" label="New CEO" /></b>
          as Chief Executive Officer of the Company with effect from
          <CddVarField field-key="ceo_appointment_date" label="Appointment date" />.
        </p>
      </div>
    </div>

    <div v-if="showResignation" class="ceo-row">
      <div class="ceo-h">RESIGNATION OF CHIEF EXECUTIVE OFFICER</div>
      <div>
        <div class="ceo-resolved">RESOLVED &ndash;</div>
        <p class="doc-p">
          That the Company do approve the resignation of
          <b><CddVarField field-key="resigning_ceo_name" label="Resigning CEO" /></b>
          as Chief Executive Officer of the Company with effect from
          <CddVarField field-key="ceo_resignation_date" label="Resignation date" />.
        </p>
      </div>
    </div>

    <div class="sign-block">
      <AgmSigners var-key="dr_Signers" board-label="Director" />
    </div>

    <p class="doc-p">Dated this <CddVarField field-key="resolution_date" label="Dated" /></p>
  </div>
</template>

<style scoped>
.ceo-title { text-align: left; border-bottom: 1.5px solid #111; padding-bottom: 4px; margin-bottom: 18px; }
.ceo-row { display: grid; grid-template-columns: 150px 1fr; gap: 16px; margin-bottom: 18px; }
.ceo-h { font-weight: 700; }
.ceo-resolved { font-weight: 700; margin-bottom: 8px; }
</style>
